import axios from "axios";


export const fetchInsuranceApiCall = () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Insurance`);

}

export const postInsuranceApiCall =(body) => {
    return axios.post(`https://arogyanxtdevapi.fundaclear.in/api/Insurance`, body);

}
